import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useApollo } from "@/apollo/client";
import { BreadcrumbsProvider } from "@/components/Breadcrumbs";
import { CopyrightsProvider } from "@/components/Copyrights";
import DefaultHeader from "@/components/DefaultHeader";
import DisabledAccess from "@/components/DisabledAccess";
import Loading from "@/components/Loading";
import { ModalProvider } from "@/components/Modal";
import NetworkNotification from "@/components/NetworkNotification";
import { NotificationProvider } from "@/components/Notification";
import { PreviousPathProvider } from "@/components/PreviousPath";
import SelectProfile from "@/components/SelectProfile";
import { useAppInit, useBuildId, useRtoasterTrack } from "@/hooks";
import { Layout } from "@/layouts";
import config from "@/lib/config";
import { maybeIPad } from "@/lib/maybeIOS";
import routes from "@/lib/routes";
import "@/styles/globals.scss";
import { ApolloProvider } from "@apollo/client";
import classnames from "classnames";
import Error from "next/error";
import { useRouter } from "next/router";
import Script from "next/script";
import { useEffect, useMemo } from "react";
import "text-security/text-security.css";
import "url-search-params-polyfill";
import { RecaptchaV3Provider } from "@/components/RecaptchaV3";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var cssVariablesIE11Polyfill = {
  __html: "\n      if (window.MSInputMethodContext && document.documentMode) {\n        var script = \"<script src='https://cdn.jsdelivr.net/gh/nuxodin/ie11CustomProperties@4.1.0/ie11CustomProperties.min.js'><script>\";\n        document.write(script);\n      }\n    "
};

function InnerApp(props) {
  var _useAppInit = useAppInit(),
      loading = _useAppInit.loading,
      user = _useAppInit.user,
      selectedProfile = _useAppInit.selectedProfile,
      disabledAccess = _useAppInit.disabledAccess,
      adultMode = _useAppInit.adultMode,
      deviceInfo = _useAppInit.deviceInfo;

  var router = useRouter();
  useRtoasterTrack(props === null || props === void 0 ? void 0 : props.adultMode, props === null || props === void 0 ? void 0 : props.referer);
  var showSelectProfile = useMemo(function () {
    if (router.pathname === routes.profilePincodeReset) return false;
    return !loading && user && !selectedProfile;
  }, [loading, user, selectedProfile]);
  var noHeader = useMemo(function () {
    if (disabledAccess) return true;
    return props.noHeader || user && !selectedProfile;
  }, [user, selectedProfile, props.noHeader, disabledAccess]);
  useEffect(function () {
    if (adultMode) {
      // ここにいれないとモーダルの色が変わらない
      var wrapper = document.querySelector("#__next");
      wrapper.classList.add("adult");
    }
  }, [adultMode]);
  return /*#__PURE__*/_jsxs("div", {
    id: "app",
    className: classnames({
      tablet: (deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.isTablet) || maybeIPad(deviceInfo),
      mobile: deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.isMobile
    }),
    children: [loading && /*#__PURE__*/_jsx(Loading, {
      fixed: true
    }), !loading && /*#__PURE__*/_jsx(NotificationProvider, {
      children: /*#__PURE__*/_jsxs(Layout, {
        noHeader: noHeader,
        noTransition: props.noTransition,
        children: [/*#__PURE__*/_jsx(NetworkNotification, {}), disabledAccess && /*#__PURE__*/_jsx(DisabledAccess, {}), !disabledAccess && /*#__PURE__*/_jsxs(_Fragment, {
          children: [!showSelectProfile && props.children, showSelectProfile && /*#__PURE__*/_jsx(SelectProfile, {
            backToPrevPath: true
          })]
        })]
      })
    })]
  });
}

function SpodApp(_ref) {
  var Component = _ref.Component,
      pageProps = _ref.pageProps,
      router = _ref.router;

  var _useBuildId = useBuildId(),
      shouldReload = _useBuildId.shouldReload;

  var client = useApollo(pageProps.initialApolloState);
  var noHeader = Component.layout === "NoHeaderLayout";
  var noTransition = Component.noTransition;
  var adult = useMemo(function () {
    var _pageProps$adultMode;

    if (true) {
      var host = window.location.origin;
      return config.host.adult === host;
    }

    return (_pageProps$adultMode = pageProps === null || pageProps === void 0 ? void 0 : pageProps.adultMode) !== null && _pageProps$adultMode !== void 0 ? _pageProps$adultMode : false;
  }, [pageProps]);
  useEffect(function () {
    var handleRouteChange = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return shouldReload();

              case 2:
                if (!_context.sent) {
                  _context.next = 4;
                  break;
                }

                window.location.reload();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function handleRouteChange() {
        return _ref2.apply(this, arguments);
      };
    }();

    router.events.on("routeChangeComplete", handleRouteChange);
    return function () {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [shouldReload]);

  if (pageProps.error) {
    // TODO: カスタムエラーページ
    return /*#__PURE__*/_jsx(Error, {
      statusCode: pageProps.error.statusCode,
      title: pageProps.error.message
    });
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Script, {
      dangerouslySetInnerHTML: cssVariablesIE11Polyfill,
      strategy: "beforeInteractive"
    }, "ie11polyfill"), /*#__PURE__*/_jsx(Script, {
      src: "https://code.jquery.com/jquery-3.5.1.min.js",
      integrity: "sha256-9/aliU8dGd2tb6OSsuzixeV4y/faTqgFtohetphbbj0=",
      crossOrigin: "anonymous"
    }, "jquery"), /*#__PURE__*/_jsx(Script, {
      src: config.streaks.js,
      strategy: "beforeInteractive"
    }, "streaksjs"), /*#__PURE__*/_jsx(Script, {
      type: "text/javascript",
      src: config.sbps.src
    }, "sbps"), /*#__PURE__*/_jsx(DefaultHeader, {
      adult: adult,
      metatags: pageProps === null || pageProps === void 0 ? void 0 : pageProps.metatags
    }), /*#__PURE__*/_jsx(ApolloProvider, {
      client: client,
      children: /*#__PURE__*/_jsx(PreviousPathProvider, {
        children: /*#__PURE__*/_jsx(BreadcrumbsProvider, {
          children: /*#__PURE__*/_jsx(CopyrightsProvider, {
            children: /*#__PURE__*/_jsx(ModalProvider, {
              children: /*#__PURE__*/_jsx(RecaptchaV3Provider, {
                children: /*#__PURE__*/_jsx(InnerApp, _objectSpread(_objectSpread({}, pageProps), {}, {
                  adultMode: adult,
                  noHeader: noHeader,
                  noTransition: noTransition,
                  children: /*#__PURE__*/_jsx(Component, _objectSpread({}, pageProps))
                }))
              })
            })
          })
        })
      })
    })]
  });
}

export default SpodApp;